import { bootVue } from "./utils/utils";
import { createApp } from "vue";
import normalizeDropdown from './utils/dropdown';
window.bootVue = bootVue;
window.createApp = createApp;
window.normalizeDropdown = normalizeDropdown;